import { render } from "./docs-cell.vue?vue&type=template&id=4201fa81&scoped=true&ts=true"
import script from "./docs-cell.vue?vue&type=script&lang=ts"
export * from "./docs-cell.vue?vue&type=script&lang=ts"

import "./docs-cell.vue?vue&type=style&index=0&id=4201fa81&scoped=true&lang=css"

import exportComponent from "C:\\agent\\_work\\44\\s\\DesignReg.VueClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4201fa81"]])

export default __exports__